export enum ContentManagerDirectoryEnum {
    Home,
    SharePoint,
    Teams,
    Libraries,
    FilesAndFolders,
    Exchange,
    Tess
  }